import { FC } from "react";
import { IconProps } from "./types";

export const MagnifyingGlassPlus: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M10.126 3.875a6.252 6.252 0 0 1 6.252 6.25 6.249 6.249 0 0 1-6.252 6.249 6.252 6.252 0 0 1-6.25-6.25 6.249 6.249 0 0 1 6.25-6.25zm0 14.373c1.907 0 3.661-.656 5.044-1.753l5.232 5.23a.937.937 0 0 0 1.324-1.324l-5.227-5.234A8.124 8.124 0 0 0 10.127 2a8.124 8.124 0 1 0 0 16.248zm-.937-4.687c0 .52.418.938.937.938.52 0 .938-.418.938-.938v-2.5h2.5c.52 0 .938-.417.938-.937a.935.935 0 0 0-.938-.937h-2.5v-2.5a.935.935 0 0 0-.938-.937.935.935 0 0 0-.937.937v2.5h-2.5a.935.935 0 0 0-.938.937c0 .52.418.938.937.938h2.5v2.5z"
      fill={fill}
    />
  </svg>
);
